<div id="map" style="width: 100%; height: 100%;"></div>